<table class="border-separate w-full" style="border-spacing: 0" role="grid">
  <thead aria-hidden="true">
    <tr>
      <th class="text-center pt-0 pb-[6px] px-0" colspan="4"></th>
    </tr>
  </thead>
  <tbody
    mat-calendar-body
    [rows]="_years"
    [todayValue]="_todayYear"
    [startValue]="_selectedYear!"
    [endValue]="_selectedYear!"
    [numCols]="4"
    [cellAspectRatio]="4 / 7"
    [activeCell]="_getActiveCell()"
    (selectedValueChange)="_yearSelected($event)"
    (activeDateChange)="_updateActiveDate($event)"
    (keyup)="_handleCalendarBodyKeyup($event)"
    (keydown)="_handleCalendarBodyKeydown($event)"
  ></tbody>
</table>
